import { IObjectPipe } from "../../models/objects";

export interface ITableKey {
    key?: string;
    label: string;
    type?: TTableColumnType;
    sortable?: boolean;
    actionIcon?: string;
    pipe?: IObjectPipe;
    color?: 'primary' | 'accent' | 'warn';
    tooltipText?: string;
    defaultValue?: string;
    showIconFieldName?: string;
    css?: string;
    isDisabledKey?: string;
}

export interface ITableEvent<T> {
    element: T;
    action: string;
}

export enum ETableColumnType {
    CURRENCY = 'CURRENCY',
    ACTION_ICON = 'ACTION_ICON',
    DOT_MENU = 'DOT_MENU',
    CHECKBOX = 'CHECKBOX',
    TOOLTIP = 'TOOLTIP',
    BADGE = 'BADGE',
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
    RADIO = 'RADIO',
    GENERIC_BADGE = 'GENERIC_BADGE'
}

export type TTableColumnType = keyof typeof ETableColumnType;

export enum ETableActionType {
    DETAIL = 'DETAIL',
    DELETE = 'DELETE',
    OPERATION = 'OPERATION',
    DOWNLOAD = 'DOWNLOAD'
}

export const FALSY_VALUES = [false, null, undefined, '', 'N', 'n', 0, '0', 'NO', 'No', 'no', 'FALSE', 'False', 'false'];
